import { render } from "./TaishakuTrend.vue?vue&type=template&id=4ecbcdda&scoped=true"
import script from "./TaishakuTrend.vue?vue&type=script&lang=js"
export * from "./TaishakuTrend.vue?vue&type=script&lang=js"

import "./TaishakuTrend.vue?vue&type=style&index=0&id=4ecbcdda&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecbcdda"]])

export default __exports__